module.exports = __webpack_public_path__ + "static/media/riskindicator.0f44eeff.svg";